import React, { Component } from 'react';

class AdminDeliveryComponent extends Component {
    onChangeBuilding = async (event) => {
        const { props } = this.props
        const { searchData, refreshSearch, search } = props
        let value = null
        if (event && event.value !== undefined) {
            value = event.value;
        }
        else if (event && event.nativeEvent && event.nativeEvent.target) {
            value = event.nativeEvent.target.value;
        }
        searchData.building = value;
        refreshSearch(searchData);
        search(searchData);
    }
    togglePopup = (type) => {
        const { showAlert } = this.props
        let msg = null
        let timeOut = 10000
        switch (type) {
            case 'DIST'://EN LA HOJA DE RUTA SE DETALLA LAS OV QUE TIENE ASIGNADAS, PERO LA SOLICITUD ES POR LOS ITEMS QUE TIENE EN LA PESTAÑA CAPACIDAD DE ALMACENAMIENTO EN LAS UNIDADES
                msg = 'Generará automáticamente una solicitud de traslado con los artículos definidos en la pestaña "Capacidad de abastecimiento" del transporte asignado a la ruta seleccionada.'
                break;
            case 'TR':
                msg = 'Genera una solicitud de traslado en base a los artículos que contiene cada documento asignado a la ruta seleccionada'
                break;
            case 'REPRINT':
                msg = 'Reimprime la hoja de ruta ya creada'
                break;
            case 'DELHR':
                msg = 'Cancela la Hoja de ruta asignada a el folio seleccionado'
                break;
            default:
                break;
        }
        if (msg) {
            showAlert({ type: 'warning', message: msg, timeOut: timeOut });
        }
    };
    render() {
        const { createNewRouteDelivery, printDelivaryAcuse, printRoadmapPreview, reprint, cancelHR } = this.props
        return (
            <div className="d-inline-flex flex-wrap align-items-start admdelivery">
                <div className="mr-3 mb-2">
                    {/* btn btn-timbra-one btn-sm botonCorrect */}
                    <button className="btn botonCorrect mr-2 mb-2 btndelivery" onClick={createNewRouteDelivery} style={{ width: 252 }}>
                        <i className="far fa-file mr-2" />
                        <span className="d-none d-xl-inline">Nueva Entrega</span>
                        <span className="d-inline d-xl-none">Entrega</span>
                    </button>

                    {/* <button className="btn btn-primary mr-2 mb-2 btndelivery" onClick={printDelivaryAcuse} style={{ width: 252 }}>
                        <i className="fas fa-print mr-2" />
                        <span className="d-none d-xl-inline">Acuse de Salida</span>
                        <span className="d-inline d-xl-none">Acuse</span>
                    </button> */}

                    <>
                        <button
                            className="btn thirdBtn mr-2 mb-2 btndelivery"
                            onClick={() => printRoadmapPreview(1)}
                            style={{ width: 252 }}
                        >
                            <i className="fa-solid fa-dolly mr-2" />
                            <span className="d-none d-xl-inline">Hoja de ruta distribuidor</span>
                            <span className="d-inline d-xl-none">Ruta Distribuidor</span>
                        </button>

                        <button
                            className="btn p-0 mr-2"
                            onClick={() => this.togglePopup('DIST')}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <i className="fa-solid fa-circle-info thirdBtn-info" />
                        </button>
                    </>
                    <>

                        <button className="btn thirdBtn mr-2 mb-2 btndelivery" onClick={() => printRoadmapPreview(2)} style={{ width: 252 }}>
                            <i className="fa-solid fa-dolly mr-2" />
                            <span className="d-none d-xl-inline">Hoja de ruta transporte</span>
                            <span className="d-inline d-xl-none">Ruta Transporte</span>
                        </button>
                        <button
                            className="btn p-0 mr-2"
                            onClick={() => this.togglePopup('TR')}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <i className="fa-solid fa-circle-info thirdBtn-info" />
                        </button>
                    </>

                    <>
                        <button
                            className="btn thirdBtn mr-2 mb-2 btndelivery"
                            onClick={() => reprint()}
                            style={{ width: 252 }}
                        >
                            <i className="fas fa-print mr-2" />
                            <span className="d-none d-xl-inline">Re-imprimir</span>
                            <span className="d-inline d-xl-none">Reimprimir</span>
                        </button>

                        <button
                            className="btn p-0 mr-2"
                            onClick={() => this.togglePopup('REPRINT')}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <i className="fa-solid fa-circle-info thirdBtn-info" />
                        </button>
                    </>

                    <>
                        <button
                            className="btn dangerBtn mr-2 mb-2 btndelivery"
                            onClick={() => cancelHR()}
                            style={{ width: 252 }}
                        >
                            <i className="fa-solid fa-xmark mr-2" />
                            <span className="d-none d-xl-inline">Cancelar Hoja de Ruta</span>
                            <span className="d-inline d-xl-none">Cancelar Hoja de Ruta</span>
                        </button>

                        <button
                            className="btn p-0 mr-2"
                            onClick={() => this.togglePopup('DELHR')}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <i className="fa-solid fa-circle-info botonCerrar-info" />
                        </button>
                    </>



                </div>

            </div>
        );
    }
}

export default AdminDeliveryComponent;
